import { ApiMethod, type ApiConfiguration } from "./shared";

export const authApi = (config: ApiConfiguration) => ({
  async changePassword(): Promise<void> {
    await config.httpService.fetch<void>({
      method: ApiMethod.POST,
      url: config.endpoints.auth.changePassword,
    });
  },
});
